export default {"src":"/_next/static/media/hand-gear.4644a43b.svg","height":84,"width":77};